import * as XLSX from "xlsx";

/** Colonnes attendues par `POST /api/geographie/import-excel` et `runGeographieExcelImport`. */
export const GEOGRAPHIE_IMPORT_COLUMNS = ["Province", "Ville", "Commune", "Quartier"] as const;

const EXAMPLE_ROWS: string[][] = [
  ["Haut-Katanga", "Lubumbashi", "Kampemba", "Golf"],
  ["Haut-Katanga", "Lubumbashi", "Kampemba", "Bel-Air"],
  ["Haut-Katanga", "Lubumbashi", "Annexe", "Kafubu"],
  ["Lualaba", "Kolwezi", "Dilala", "Joli Site"],
  ["Haut-Katanga", "Likasi", "", ""],
  ["Haut-Katanga", "", "", ""],
];

const INSTRUCTIONS_ROWS: string[][] = [
  ["Import référentiel géographique — Espoir Afrique SAS"],
  [""],
  ["Feuille à remplir", "« Données » (ne pas renommer les en-têtes de colonnes)."],
  ["Colonnes", "Province | Ville | Commune | Quartier"],
  [""],
  ["Règles"],
  ["1", "Chaque ligne décrit un chemin Province → Ville → Commune → Quartier."],
  ["2", "La colonne Province est obligatoire sur chaque ligne importée."],
  ["3", "Ville, Commune et Quartier sont optionnels : laissez vide si le niveau n’existe pas encore."],
  ["4", "Les doublons (même hiérarchie, insensible à la casse) sont ignorés sans erreur."],
  ["5", "Supprimez les lignes d’exemple avant import si vous ne les voulez pas en base."],
  ["6", "Conservez la première ligne d’en-têtes exactement : Province, Ville, Commune, Quartier."],
  [""],
  ["Après remplissage", "Admin → Géographie → « Importer référentiel géographique » → prévisualiser → Importer."],
];

/**
 * Télécharge le modèle Excel d’import géographique (.xlsx).
 */
export function downloadGeographieImportTemplate(filename = "modele-import-geographie.xlsx"): void {
  const wb = XLSX.utils.book_new();

  const dataSheet = XLSX.utils.aoa_to_sheet([
    [...GEOGRAPHIE_IMPORT_COLUMNS],
    ...EXAMPLE_ROWS,
  ]);
  dataSheet["!cols"] = [{ wch: 18 }, { wch: 16 }, { wch: 14 }, { wch: 14 }];
  XLSX.utils.book_append_sheet(wb, dataSheet, "Données");

  const instructionsSheet = XLSX.utils.aoa_to_sheet(INSTRUCTIONS_ROWS);
  instructionsSheet["!cols"] = [{ wch: 22 }, { wch: 72 }];
  XLSX.utils.book_append_sheet(wb, instructionsSheet, "Instructions");

  XLSX.writeFile(wb, filename);
}
